module.exports = __webpack_public_path__ + "static/media/football-ball.0cc6e729.svg";